import { useState } from 'react';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { attachRequiredDocument, recordReadinessOverride } from '../../../jobs.api';

/** The readiness checklist's two writes (gitaumoses4/chukua#36) — both reload the job on success, same pattern as `useJobActions`. */
export function useJobReadiness(jobId: string, reload: () => Promise<void>) {
  const [attachError, setAttachError] = useState<string | null>(null);
  const [overrideError, setOverrideError] = useState<string | null>(null);
  const toast = useToast();

  async function attach(requiredDocumentTypeId: string, uploadId: string, itemLabel: string): Promise<void> {
    setAttachError(null);
    try {
      await attachRequiredDocument(jobId, requiredDocumentTypeId, uploadId);
      await reload();
      toast.success(`${itemLabel} attached`);
    } catch (err) {
      setAttachError(apiErrorMessage(err) ?? `Could not attach ${itemLabel} — try again.`);
    }
  }

  async function override(itemKey: string, approverId: string, reason: string, itemLabel: string): Promise<boolean> {
    setOverrideError(null);
    try {
      await recordReadinessOverride(jobId, { itemKey, approverId, reason });
      await reload();
      toast.success(`${itemLabel} overridden`);
      return true;
    } catch (err) {
      setOverrideError(apiErrorMessage(err) ?? `Could not override ${itemLabel} — try again.`);
      return false;
    }
  }

  return { attachError, overrideError, attach, override };
}
